import { useQuery } from '@tanstack/react-query';
import { api } from './client.js';
import { getSessionToken } from '../lib/auth.js';
import type {
  Connection,
  Me,
  PersonalBot,
  Prefs,
  SettingsPayload,
  Status,
  ToolCounts,
  VersionInfo,
} from './types.js';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<Me>('/api/me'),
    enabled: !!getSessionToken(),
    retry: false,
  });
}

export function useStatus() {
  return useQuery({
    queryKey: ['status'],
    queryFn: () => api.get<Status>('/status'),
    refetchInterval: 5000,
  });
}

export function useConnections() {
  return useQuery({
    queryKey: ['connections'],
    queryFn: () => api.get<Connection[]>('/api/connections'),
  });
}

export function useToolCounts(refresh = false) {
  return useQuery({
    queryKey: ['tool-counts', refresh],
    queryFn: () => api.get<ToolCounts>(`/api/connections/tool-counts${refresh ? '?refresh=1' : ''}`),
  });
}

export function usePrefs() {
  return useQuery({
    queryKey: ['prefs'],
    queryFn: () => api.get<Prefs>('/api/prefs'),
  });
}

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<SettingsPayload>('/api/settings'),
  });
}

export function usePersonalBot() {
  return useQuery({
    queryKey: ['personal-bot'],
    queryFn: () => api.get<PersonalBot>('/api/user/personal-bot'),
  });
}

export function useVersion() {
  return useQuery({
    queryKey: ['version'],
    queryFn: () => api.get<VersionInfo>('/version'),
    staleTime: 60_000,
  });
}

export function useOllamaStatus() {
  return useQuery({
    queryKey: ['ollama-status'],
    queryFn: () => api.get<{ available: boolean }>('/api/server/ollama-status'),
  });
}
